// Balance shown to players = cash + Free Play; this line says how much of it is Free Play.
export const playable = (u) => Number(u?.credits || 0) + Number(u?.bonus_credits || 0);

export const FreePlayNote = ({ user, testId = 'free-play-note', className = '' }) => {
    const fp = Number(user?.bonus_credits || 0);
    if (fp <= 0) return null;
    return (
        <span className={`block text-[11px] font-bold text-[#39FF14] ${className}`} data-testid={testId}
            title="Free Play is part of your balance. It is used first and must be played through once before winnings can be cashed out.">
            incl. ${fp.toFixed(2)} Free Play
        </span>
    );
};
